$(function () {
    if($('#bookingPeopleCountSet').length === 0) {
        return;
    }

    $(".input-button-plus").click(function () {
        let inputField = $(this).siblings('input[type="number"]');
        let currentValue = parseInt(inputField.val());
        let maxValue = inputField.attr('max') ? parseInt(inputField.attr('max')) : Infinity;
        if (currentValue < maxValue) {
            inputField.val(currentValue + 1).change();
        }
    });

    $(".input-button-minus").click(function () {
        let inputField = $(this).siblings('input[type="number"]');
        let currentValue = parseInt(inputField.val());
        if (currentValue > 0) {
            inputField.val(currentValue - 1).change();
        }
    });


    $("#setPeopleCount").click(function (e) {
        e.preventDefault();
        let uuid = $("#uuid").val();
        let adultCount = parseInt($("#people_quantity_adult").val());
        let youthCount = parseInt($("#people_quantity_youth").val());
        let childrenCount = parseInt($("#people_quantity_children").val());

        let url = "/booking/?uuid=" + uuid +
            "&nop=" + adultCount +
            "&nop_y=" + youthCount +
            "&nop_c=" + childrenCount;

        window.location.href = url;
    });
});

